import { Component, ViewChild } from '@angular/core';
import { NgIf } from '@angular/common';
import { MaskComponent } from '../../organisms/mask/mask.component';
import {
  NavigationEnd,
  Router,
  RouterLink,
  RouterOutlet,
} from '@angular/router';
import { SharedModule } from 'primeng/api';
import { Sidebar, SidebarModule } from 'primeng/sidebar';
import { filter } from 'rxjs';
import { SidebarService } from '../../../services/menu/sidebar.service';
import { RoutingService } from '../../../services/routing.service';
import { Button } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { HeaderComponent } from '../../atoms/header/header.component';

@Component({
  selector: 'app-tool-overlay',
  standalone: true,
  imports: [
    MaskComponent,
    NgIf,
    RouterOutlet,
    SharedModule,
    SidebarModule,
    Button,
    RouterLink,
    DividerModule,
    HeaderComponent,
  ],
  templateUrl: './tool-overlay.component.html',
  styleUrl: './tool-overlay.component.scss',
})
export class ToolOverlayComponent {
  @ViewChild('sidebarRef') sidebarRef!: Sidebar;

  public openSidebar = false;

  constructor(
    private router: Router,
    private routingService: RoutingService,
    protected sidebarService: SidebarService
  ) {
    this.openSidebar = false;
    this.setRouterEvents();
  }

  /**
   * Handles the logic to be executed when the overlay is closed.
   *
   * @return {void} This method does not return a value.
   */
  onOverlayClose(): void {
    this.routingService.navigateToRoot();
  }

  /**
   * Subscribes to the router events and sets the application state based on specific navigation events.
   * Filters the router events to only process `NavigationEnd` events. Determines if the URL contains an overlay parameter
   * and updates the `openSidebar` property accordingly.
   *
   * @return {void} Does not return any value.
   */
  setRouterEvents(): void {
    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd
        )
      )
      .subscribe((event: NavigationEnd) => {
        this.openSidebar = event.url.toString().indexOf('(overlay:') > -1;
      });
  }

  /**
   * Handles the closure of a sidebar or related component.
   *
   * @param {any} e - The event or data triggering the closure callback.
   * @return {void} Does not return a value.
   */
  closeCallback(e: any): void {
    this.sidebarRef.close(e);
  }
}
